import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useToast } from '../hooks/use-toast';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RegistrationModal = ({ isOpen, onClose, settings, utmData }) => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, ...utmData })
      });
      const data = await res.json();
      if (data.success) {
        sessionStorage.setItem('registered_name', formData.name);
        setFormData({ name: '', email: '', phone: '' });
        onClose();
        navigate('/thankyou');
      } else {
        toast({ title: "Error", description: "Something went wrong. Please try again.", duration: 5000 });
      }
    } catch {
      toast({ title: "Error", description: "Something went wrong. Please try again.", duration: 5000 });
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-black text-center mb-2">
            Register for Free Webinar
          </DialogTitle>
          <DialogDescription className="text-center text-lg">
            <span className="font-bold text-[#FF6B35]">{settings?.date || '19th March 2026 (Thursday)'}</span>
            <br />
            <span className="font-bold">{settings?.time || '8.00PM (Singapore Time)'}</span>
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-6 mt-6">
          <div className="space-y-2">
            <Label htmlFor="name" className="text-lg font-semibold">Full Name *</Label>
            <Input
              data-testid="register-name-input"
              id="name" name="name" type="text" required
              value={formData.name} onChange={handleChange}
              placeholder="Enter your full name" className="h-12 text-lg"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-lg font-semibold">Email Address *</Label>
            <Input
              data-testid="register-email-input"
              id="email" name="email" type="email" required
              value={formData.email} onChange={handleChange}
              placeholder="your.email@example.com" className="h-12 text-lg"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="phone" className="text-lg font-semibold">Phone Number *</Label>
            <Input
              data-testid="register-phone-input"
              id="phone" name="phone" type="tel" required
              value={formData.phone} onChange={handleChange}
              placeholder="+65 1234 5678" className="h-12 text-lg"
            />
          </div>
          <Button
            data-testid="register-submit-btn"
            type="submit" disabled={loading}
            className="w-full bg-[#FF6B35] hover:bg-[#FF5722] text-white text-xl font-bold py-6 rounded-lg shadow-xl transform transition-all duration-300 hover:scale-105"
          >
            {loading ? 'Registering...' : 'REGISTER NOW'}
          </Button>
          <p className="text-center text-sm text-gray-500">
            Your information is secure and will only be used for webinar registration.
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RegistrationModal;
